import { render } from "./PointHistories.vue?vue&type=template&id=79f52feb&scoped=true"
import script from "./PointHistories.vue?vue&type=script&lang=js"
export * from "./PointHistories.vue?vue&type=script&lang=js"

import "./PointHistories.vue?vue&type=style&index=0&id=79f52feb&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79f52feb"]])

export default __exports__